// Liste simplifiée d'indicatifs téléphoniques avec drapeaux
// (peut être étendue si besoin)

export const phoneCountryOptions = [
  { code: 'BE', dialCode: '+32', flag: '🇧🇪' },
  { code: 'FR', dialCode: '+33', flag: '🇫🇷' },
  { code: 'CH', dialCode: '+41', flag: '🇨🇭' },
  { code: 'DE', dialCode: '+49', flag: '🇩🇪' },
  { code: 'AT', dialCode: '+43', flag: '🇦🇹' },
  { code: 'NL', dialCode: '+31', flag: '🇳🇱' },
  { code: 'LU', dialCode: '+352', flag: '🇱🇺' },
  { code: 'ES', dialCode: '+34', flag: '🇪🇸' },
  { code: 'IT', dialCode: '+39', flag: '🇮🇹' },
  { code: 'PT', dialCode: '+351', flag: '🇵🇹' },
  { code: 'GB', dialCode: '+44', flag: '🇬🇧' },
  { code: 'IE', dialCode: '+353', flag: '🇮🇪' },
  { code: 'US', dialCode: '+1', flag: '🇺🇸' },
  { code: 'CA', dialCode: '+1', flag: '🇨🇦' },
  { code: 'BR', dialCode: '+55', flag: '🇧🇷' },
  { code: 'SN', dialCode: '+221', flag: '🇸🇳' },
  { code: 'CI', dialCode: '+225', flag: '🇨🇮' },
  { code: 'CM', dialCode: '+237', flag: '🇨🇲' },
  { code: 'CD', dialCode: '+243', flag: '🇨🇩' },
  { code: 'ZA', dialCode: '+27', flag: '🇿🇦' },
  { code: 'MA', dialCode: '+212', flag: '🇲🇦' },
  { code: 'DZ', dialCode: '+213', flag: '🇩🇿' },
  { code: 'TN', dialCode: '+216', flag: '🇹🇳' },
  { code: 'TR', dialCode: '+90', flag: '🇹🇷' },
  { code: 'RU', dialCode: '+7', flag: '🇷🇺' },
  { code: 'CN', dialCode: '+86', flag: '🇨🇳' },
  { code: 'JP', dialCode: '+81', flag: '🇯🇵' },
  { code: 'KR', dialCode: '+82', flag: '🇰🇷' },
  { code: 'IN', dialCode: '+91', flag: '🇮🇳' },
  { code: 'AU', dialCode: '+61', flag: '🇦🇺' },
  { code: 'NZ', dialCode: '+64', flag: '🇳🇿' },
];


